<template>
  <div class="form-input">
    <label class="label-input">{{ label }}</label>

    <div class="custom-select" :class="{ disabled: isDisabled }">
      <input
        type="date"
        class="date-input"
        :value="value"
        :disabled="isDisabled"
        @input="updateDate($event.target.value)"
      />
    </div>

    <p :class="[hasError ? 'error' : 'no-error']">
      {{ hasError ? error?.esMessage : "" }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { MessageError } from "@/business/shared/commons/validator/validatorsTypes";

export default defineComponent({
  name: "CustomDatePicker",
  props: {
    label: { type: String, default: "" },
    value: { type: String, default: "" },
    isDisabled: { type: Boolean, default: false },
    error: { type: Object as () => MessageError, default: null },
    hasError: { type: Boolean, default: false },
  },
  emits: ["update:text", "changeDate"],
  setup(props, { emit }) {
    const updateDate = (val: string) => {
      emit("update:text", val);
      emit("changeDate", val);
    };
    return { updateDate };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/datePickerStyle";
</style>
